import React from 'react';
import { SHARING_ENDED } from './sharedQueries';

/**
 * Shown in place of a shared conversation a participant had open when the
 * owner stopped sharing it or deleted it (PRD-1571 R4). Same card as the
 * Frame 3 notice; nothing of the conversation stays on screen.
 */
function SharingEndedNotice() {
  const { title, text } = SHARING_ENDED;
  return (
    <div className="resui-card locked-query-notice" role="status">
      <h3 className="locked-query-notice-title">{title}</h3>
      <p className="locked-query-notice-text">{text}</p>
    </div>
  );
}

export default SharingEndedNotice;
